import React from "react"
import PropTypes from "prop-types"
import { Modal, Typography, Flex } from "antd"
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"

const { Title, Text } = Typography

const CONFIG = {
  signed: {
    icon: <CheckCircleOutlined style={{ fontSize: 24, color: "#1677ff" }} />,
    iconBg: "#e6f4ff",
    title: "Waiver Already Signed",
    message: "You have already signed this waiver."
  },
  canceled: {
    icon: <CloseCircleOutlined style={{ fontSize: 24, color: "#ff4d4f" }} />,
    iconBg: "#fff1f0",
    title: "Booking Canceled",
    message: "This booking has been canceled."
  }
}

export const WaiverStatusModal = ({ type }) => {
  const { icon, iconBg, title, message } = CONFIG[type] || CONFIG.canceled

  return (
    <Flex align="center" justify="center" style={{ minHeight: "100vh", background: "#f5f5f5" }}>
      <Modal
        open
        footer={null}
        closable={false}
        centered
        width={440}
        styles={{ mask: { background: "transparent" } }}
      >
        <div style={{ textAlign: "center" }}>
          <Flex align="center" justify="center" style={{ width: 56, height: 56, borderRadius: "50%", background: iconBg, margin: "0 auto 16px" }}>
            {icon}
          </Flex>
          <Title level={4} style={{ marginBottom: 4 }}>{title}</Title>
          <Text type="secondary">{message}</Text>
        </div>
      </Modal>
    </Flex>
  )
}

WaiverStatusModal.propTypes = {
  type: PropTypes.oneOf(["signed", "canceled"]).isRequired
}
